@if (form) {
  <form [formGroup]="form.formGroup" class="main-container">
    <div class="forms-section">
      @for (field of form.renderFields; let i = $index; track field.name) {
        <div class="rims-form-row-wrapper">
          <div class="rims-form-row-field">
            @switch (field.fieldType) {
              @case ('input-text') {
                @if (!isRimsSetItemField(field.rawFieldData)) {
                  <mat-form-field class="form-field" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                    <mat-label>
                      {{ field.displayName }}
                      @if (field.description) {
                        <mat-icon class="form-field-tooltip-icon" [matTooltip]="field.description">info</mat-icon>
                      }
                    </mat-label>
                    <input
                      matInput
                      [placeholder]="field.placeholder ?? ''"
                      [formControlName]="field.name"
                      type="text"
                    />
                    <mat-error [appDecimalError]="form.formGroup.get(field.name)"></mat-error>

                    @if (form.formGroup.get(field.name)?.value) {
                      <button
                        type="button"
                        tabindex="-1"
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="onClearField($event, field.name)"
                      >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>
                }
              }

              @case ('input-number') {
                <mat-form-field class="form-field" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                  <mat-label>
                    {{ field.displayName }}
                    @if (field.description) {
                      <mat-icon class="form-field-tooltip-icon" [matTooltip]="field.description">info</mat-icon>
                    }
                  </mat-label>
                  <input matInput [placeholder]="field.placeholder ?? ''" [formControlName]="field.name" type="text" />

                  @if (form.formGroup.get(field.name)?.value !== null && form.formGroup.get(field.name)?.value !== '') {
                    <button
                      type="button"
                      tabindex="-1"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="onClearField($event, field.name)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }

              @case ('datepicker') {
                <mat-form-field class="form-field" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                  <mat-label>
                    {{ field.displayName }}
                    @if (field.description) {
                      <mat-icon class="form-field-tooltip-icon" [matTooltip]="field.description">info</mat-icon>
                    }
                  </mat-label>
                  <input
                    matInput
                    [matDatepicker]="matPicker"
                    [formControlName]="field.name"
                    [placeholder]="field.placeholder ?? ''"
                    [readonly]="true"
                    [value]="field.value"
                  />
                  <mat-datepicker-toggle matPrefix [for]="matPicker"></mat-datepicker-toggle>

                  @if (form.formGroup.get(field.name)?.value) {
                    <button
                      type="button"
                      tabindex="-1"
                      matIconSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="onClearField($event, field.name)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }

                  <mat-datepicker #matPicker [attr.id]="'matPicker_' + i"></mat-datepicker>
                </mat-form-field>
              }

              @case ('dropdown') {
                <mat-form-field class="form-field" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                  <mat-label>
                    {{ field.displayName }}
                    @if (field.description) {
                      <mat-icon class="form-field-tooltip-icon" [matTooltip]="field.description">info</mat-icon>
                    }
                  </mat-label>
                  <mat-select [formControlName]="field.name">
                    @for (option of field.options; track option) {
                      <mat-option class="form-field-select-option" [value]="option.value">
                        {{ option.displayValue }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (form.formGroup.get(field.name)?.value) {
                    <button
                      type="button"
                      tabindex="-1"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="onClearField($event, field.name)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }

              @case ('checkbox') {
                <mat-form-field class="form-field" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                  <mat-label>
                    {{ field.displayName }}
                    @if (field.description) {
                      <mat-icon class="form-field-tooltip-icon" [matTooltip]="field.description">info</mat-icon>
                    }
                  </mat-label>
                  <mat-select [formControlName]="field.name">
                    <mat-option class="form-field-select-option" [value]="false"> False </mat-option>
                    <mat-option class="form-field-select-option" [value]="true"> True </mat-option>
                  </mat-select>
                  @if (
                    form.formGroup.get(field.name)?.value !== null &&
                    typeof form.formGroup.get(field.name)?.value !== 'undefined'
                  ) {
                    <button
                      type="button"
                      tabindex="-1"
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="onClearField($event, field.name)"
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }

              @case ('form-redirect') {
                <p class="form-field-label body-medium">{{ field.displayName }}</p>
                <button class="form-edit-button button-primary" mat-flat-button (click)="requestForm(field)">
                  Edit
                </button>
              }

              @case ('text') {
                <p class="form-field-label body-medium">{{ field.displayName }}</p>
                {{ field.value }}
              }
            }
          </div>
        </div>
      }
    </div>
  </form>
}
